/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationSettingsDto } from '../../models/application-settings-dto';
import { AvWeightQuickInsightDto } from '../../models/av-weight-quick-insight-dto';

export interface UpdateSetting_1$Params {
      body: AvWeightQuickInsightDto
}

export function updateSetting_1(http: HttpClient, rootUrl: string, params: UpdateSetting_1$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplicationSettingsDto>> {
  const rb = new RequestBuilder(rootUrl, updateSetting_1.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplicationSettingsDto>;
    })
  );
}

updateSetting_1.PATH = '/api/application/settings/AvWeight';
